import { FC, ReactNode, useId } from "react";
import { Swiper } from "swiper/react";
import { Navigation, Scrollbar, Mousewheel, Pagination, FreeMode } from "swiper/modules";
// @ts-ignore
import "swiper/css";
// @ts-ignore
import "swiper/css/navigation";
// @ts-ignore
import "swiper/css/pagination";

interface ProductSliderProps {
  isMobile: boolean;
  className: string;
  children: ReactNode;
  spaceBetween?: number;
  showMobilePagination?: boolean;
  showDesktopNavigation?: boolean;
  desktopNavigationClassName?: string;
  mobileTrailingOffset?: number;
}

const ProductSlider: FC<ProductSliderProps> = ({
  isMobile,
  className,
  children,
  spaceBetween = 0,
  showMobilePagination = false,
  showDesktopNavigation = true,
  desktopNavigationClassName = "",
  mobileTrailingOffset = 0,
}) => {
  const navigationId = useId().replace(/[^a-zA-Z0-9_-]/g, "");
  const prevClassName = `swiper-button-prev-${navigationId}`;
  const nextClassName = `swiper-button-next-${navigationId}`;
  const navigationExtraClass = desktopNavigationClassName.trim();
  const trailingOffset = isMobile ? mobileTrailingOffset : 0;

  return (
    <Swiper
      modules={[Navigation, Scrollbar, Mousewheel, Pagination, FreeMode]}
      spaceBetween={spaceBetween}
      className={className}
      slidesPerView={"auto"}
      slidesOffsetAfter={trailingOffset}
      watchOverflow
      centeredSlides={false}
      centerInsufficientSlides={false}
      resistanceRatio={0}
      mousewheel={
        !isMobile
          ? {
              enabled: true,
              forceToAxis: true,
              releaseOnEdges: true,
              sensitivity: 0.8,
              thresholdDelta: 6,
              thresholdTime: 100,
            }
          : false
      }
      scrollbar={
        !isMobile
          ? {
              hide: false,
              draggable: true,
              snapOnRelease: false,
            }
          : undefined
      }
      freeMode={
        {
          enabled: true,
          sticky: false,
          momentum: true,
          minimumVelocity: isMobile ? 0.01 : 0.02,
          momentumRatio: isMobile ? 0.75 : 0.9,
          momentumVelocityRatio: isMobile ? 0.75 : 0.9,
          momentumBounce: false,
        }
      }
      touchReleaseOnEdges
      pagination={showMobilePagination && isMobile}
      navigation={
        !isMobile && showDesktopNavigation
          ? {
              nextEl: `.${nextClassName}`,
              prevEl: `.${prevClassName}`,
              disabledClass: "swiper-button-disabled",
            }
          : false
      }
    >
      {children}
      {!isMobile && showDesktopNavigation && (
        <>
          <div
            className={`${prevClassName} swiper-button-prev${
              navigationExtraClass ? ` ${navigationExtraClass}` : ""
            }`}
          />
          <div
            className={`${nextClassName} swiper-button-next${
              navigationExtraClass ? ` ${navigationExtraClass}` : ""
            }`}
          />
        </>
      )}
    </Swiper>
  );
};

export default ProductSlider;
